<template>
  <tbody v-if="payment" class="tbody">
    <tr style="height: 50px">
      <td>{{ payment.seqNo }}</td>
      <td>{{ payment.refNo }}</td>
      <td>{{ payment.entity ? payment.entity.name : "" }}</td>
      <td>{{ formatDate(payment.date) }}</td>
      <td>{{ payment.createdAt | moment("HH:mm DD MMM YYYY") }}</td>
      <td>{{ payment.no }}</td>
      <td>{{ payment.vendorName ? payment.vendorName : "Other" }}</td>
      <td>{{ payment.paymentMode }}</td>
      <td>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small :color="statusColor">
              <h3>
                <span>{{ payment.statusStr }}</span>
                <v-icon>mdi-menu-down</v-icon>
              </h3>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-on:click="changeStatus(payment, 0)"
              v-show="payment.status == 1"
            >
              <v-list-item-title>{{ $i18n.t("Mark Pending") }}</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item
              v-on:click="changeStatus(payment, 1)"
              v-show="payment.status == 0 || payment.status == null"
            >
              <v-list-item-title>{{ $i18n.t("Mark Paid") }}</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </td>
      <td class="text-right">
        {{ payment.totalAmount }}
      </td>
      <td class="text-right">
        {{ subtract(payment.totalAmount, payment.amountUsed) }}
      </td>
      <td class="text-right">
        {{ payment.amountPaid }}
      </td>
      <td class="text-right">{{ payment.tdsAmount }}</td>
      <td>
        <z-confirm-button
          v-show="payment.showDelete"
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Payment ?')"
          @click="deletePayment(payment._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/paymentdone/' + payment._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PaymentDoneRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
})
export default class PaymentDoneRow extends Vue {
  payment = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  get statusColor() {
    if (this.payment.status == 0) {
      return "default";
    }
    if (this.payment.status == 1) {
      return "cyan lighten-2";
    }
    return "";
  }

  async changeStatus(payment, status) {
    common.setLoading(true);
    try {
      await doGet(
        "/api/paymentmade/" + payment._id + "/status/" + status + "/update"
      );
      common.showMessage("Status Updated Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  subtract(from, value) {
    if (!this.isSet(from)) from = 0;
    if (!this.isSet(value)) value = 0;
    return this.round(from) - this.round(value);
  }

  round(value) {
    return Number(Math.round(value + "e" + 2) + "e-" + 2);
  }

  async deletePayment(paymentmade_id) {
    common.setLoading(true);
    try {
      await doGet("/api/paymentmade/" + paymentmade_id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.payment = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.payment = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
